(() => {
  const GALLERY_ID = "AllMediaGallery";
  const UI_CLASS = "vmf-slider-ui";

  function gallery() {
    return document.getElementById(GALLERY_ID);
  }

  function isHidden(el) {
    return !el || getComputedStyle(el).display === "none";
  }

  function getVisibleItems(g) {
    return Array.from(g.querySelectorAll(".media-item")).filter((el) => !isHidden(el));
  }

  function ensureUI(g) {
    // Only on mobile
    if (window.matchMedia("(min-width: 750px)").matches) return;

    // If already exists, reuse
    let ui = g.parentElement.querySelector(`.${UI_CLASS}`);
    if (ui) return ui;

    ui = document.createElement("div");
    ui.className = UI_CLASS;

    const prev = document.createElement("button");
    prev.className = "vmf-slider-btn vmf-prev";
    prev.type = "button";
    prev.setAttribute("aria-label", "Previous image");
    prev.innerHTML = `<svg class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill="currentColor" fill-rule="evenodd"
                        d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                        clip-rule="evenodd"></path>
                      </svg>`;

    const count = document.createElement("div");
    count.className = "vmf-slider-count";
    count.textContent = "1/1";

    const next = document.createElement("button");
    next.className = "vmf-slider-btn vmf-next";
    next.type = "button";
    next.setAttribute("aria-label", "Next image");
    next.innerHTML = `<svg class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill="currentColor" fill-rule="evenodd"
                        d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                        clip-rule="evenodd"></path>
                      </svg>`;

    ui.appendChild(prev);
    ui.appendChild(count);
    ui.appendChild(next);

    // Insert after gallery
    g.insertAdjacentElement("afterend", ui);

    return ui;
  }

  function scrollToIndex(g, idx) {
    const items = getVisibleItems(g);
    if (!items.length) return;

    const clamped = Math.max(0, Math.min(idx, items.length - 1));
    const el = items[clamped];

    // Scroll so that slide starts at the beginning (works with padding)
    g.scrollTo({ left: el.offsetLeft, behavior: "smooth" });
  }

  function getActiveIndex(g) {
    const items = getVisibleItems(g);
    if (!items.length) return 0;

    const left = g.scrollLeft;
    let bestIdx = 0;
    let bestDist = Infinity;

    items.forEach((el, i) => {
      const dist = Math.abs(el.offsetLeft - left);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    });

    return bestIdx;
  }

  function updateUI(g) {
    const ui = g.parentElement.querySelector(`.${UI_CLASS}`);
    if (!ui) return;

    const items = getVisibleItems(g);
    const total = items.length || 1;
    const idx = Math.min(getActiveIndex(g), total - 1);

    ui.querySelector(".vmf-slider-count").textContent = `${idx + 1}/${total}`;

    const prev = ui.querySelector(".vmf-prev");
    const next = ui.querySelector(".vmf-next");
    prev.disabled = idx <= 0;
    next.disabled = idx >= total - 1;
  }

  function bind(g) {
    if (!g) return;
    const ui = ensureUI(g);
    if (!ui) return;

    // Click arrows
    ui.querySelector(".vmf-prev").addEventListener("click", () => {
      const idx = getActiveIndex(g);
      scrollToIndex(g, idx - 1);
    });

    ui.querySelector(".vmf-next").addEventListener("click", () => {
      const idx = getActiveIndex(g);
      scrollToIndex(g, idx + 1);
    });

    // Update counter on scroll (throttled)
    let t = null;
    g.addEventListener("scroll", () => {
      if (t) return;
      t = setTimeout(() => {
        t = null;
        updateUI(g);
      }, 80);
    });

    // On resize, re-evaluate UI
    window.addEventListener("resize", () => {
      updateUI(g);
    });

    // When your color filter runs, you should dispatch this event (see step 3)
    document.addEventListener("vmf:gallery-updated", () => {
      // Jump to first visible slide after filtering
      scrollToIndex(g, 0);
      updateUI(g);
    });

    // Initial
    scrollToIndex(g, 0);
    updateUI(g);
  }

  document.addEventListener("DOMContentLoaded", () => {
    bind(gallery());
  });
})();
